import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'mochi-react-component';
import { devicePlateForm } from 'utils/device-util';
import className from 'classnames/bind';
import styles from 'feature/common/landing/header/index.module.scss';
import plate from 'images/landing/header_plate.png';
import { isMochiService } from 'config';

const cx = className.bind(styles);

const Header = () => {
  const { t } = useTranslation();
  const [mobileShow, setMobileShow] = useState(false);
  const [plateShow, setPlateShow] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    if (imgLoaded) {
      setTimeout(() => {
        setMobileShow(true);
      }, 450);
      setTimeout(() => {
        setPlateShow(true);
      }, 700);
    }
  });

  const mobileImg = () => {
    return devicePlateForm() === 'desktop' ? `${t('images:header_mobile')}` : `${t('images:header_mobile_m')}`;
  };

  const mobileClass = cx({
    mobile: true,
    show: mobileShow,
  });

  const plateClass = cx({
    plate: true,
    show: plateShow,
  });

  const fontSize = () => {
    return devicePlateForm() === 'desktop' ? `18px` : `16px`;
  };

  return (
    <section className={styles.header}>
      <div className={styles.content}>
        <h1>
          {t('landing.header.title')}
          <br />
          {t('landing.header.subtitle')}
        </h1>
        <div className={styles.msg}>
          {t('landing.header.message')}
          {isMochiService && (
            <a href="#Download">
              <Button type="text" theme="orange" customStyle={{ fontSize: fontSize() }}>
                {t('landing.header.download_now')}
              </Button>
            </a>
          )}
        </div>
      </div>
      <div className={styles.animation}>
        <img className={mobileClass} src={mobileImg()} alt="mobile" onLoad={() => setImgLoaded(true)} loading="lazy" />
        <img className={plateClass} src={plate} alt="plate" loading="lazy" />
      </div>
    </section>
  );
};

export default Header;
